import { useQuery, useMutation } from "react-query";
import {
  authAgentGetMe,
  authAgentsChangePassword,
} from "./auth-agents-service";

export const useAuthAgentGetMe = () => {
  return useQuery("agents/getme", () => authAgentGetMe());
};

export const useAuthAgentChangePassword = () => {
  return useMutation((data: any) => authAgentsChangePassword(data));
};
